import React, { useEffect, useState, useRef } from 'react';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CartIcon } from './CartIcon';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsServicesDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Scroll to top when navigating to a new page
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <header className="bg-white shadow-md sticky top-0 z-50" data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="flex justify-between items-center h-20" data-id="element-217">
          <div className="flex items-center" data-id="element-218">
            <div className="flex-shrink-0 flex items-center" data-id="element-219">
              <Link to="/" onClick={scrollToTop} data-id="element-220">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4VmNYvHZzkjgPETo7E9Qew/Toddler-Time-Logo-nobackground-300x286.png" alt="Toddler Time Soft Play Rental & More Logo" className="h-16 w-auto" data-id="element-221" />
              </Link>
              <span className="ml-3 text-primary-600 font-heading font-bold text-xl md:text-2xl hidden sm:block" data-id="element-222">
                Toddler Time ATL
              </span>
            </div>
          </div>

          {/* Desktop navigation */}
          <nav className="hidden lg:ml-6 lg:flex lg:items-center lg:space-x-6" data-id="element-223">
            <Link to="/" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 transition" onClick={scrollToTop} data-id="element-224">
              Home
            </Link>

            <Link to="/about" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 transition" onClick={scrollToTop} data-id="element-225">
              About
            </Link>

            {/* Services dropdown */}
            <div className="relative" ref={dropdownRef} data-id="element-226">
              <button className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 transition flex items-center" onClick={() => setIsServicesDropdownOpen(!isServicesDropdownOpen)} data-id="element-227">
                Packages
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-228" />
              </button>
              {isServicesDropdownOpen && <div className="absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10" data-id="element-229">
                  <div className="py-1" role="menu" aria-orientation="vertical" data-id="element-230">
                    <Link to="/softplay" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600" role="menuitem" onClick={() => {
                  setIsServicesDropdownOpen(false);
                  scrollToTop();
                }} data-id="element-231">
                      Colorful Soft Play
                    </Link>
                    <Link to="/luxurysoftplay" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600" role="menuitem" onClick={() => {
                  setIsServicesDropdownOpen(false);
                  scrollToTop();
                }} data-id="element-232">
                      Luxury Soft Play
                    </Link>
                    <Link to="/bouncehouse" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-600" role="menuitem" onClick={() => {
                  setIsServicesDropdownOpen(false);
                  scrollToTop();
                }} data-id="element-233">
                      Bounce Houses
                    </Link>
                  </div>
                </div>}
            </div>

            <Link to="/gallery" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 transition" onClick={scrollToTop} data-id="element-234">
              Gallery
            </Link>

            <Link to="/faq" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 transition" onClick={scrollToTop} data-id="element-235">
              FAQ
            </Link>

            <Link to="/contact" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-primary-600 transition" onClick={scrollToTop} data-id="element-236">
              Contact
            </Link>

            <Link to="/cart" className="inline-flex items-center px-6 py-2.5 border-2 border-secondary-500 text-sm font-bold rounded-full shadow-sm text-white bg-secondary-500 hover:bg-secondary-600 hover:border-secondary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary-500 transition-all" onClick={scrollToTop} data-id="element-237">
              BOOK NOW
            </Link>

            <Link to="/cart" className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-primary-600 transition" onClick={scrollToTop} data-id="element-238">
              <CartIcon data-id="element-239" />
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="flex items-center lg:hidden space-x-3" data-id="element-240">
            {/* Mobile Cart Icon with Badge */}
            <Link to="/cart" className="relative inline-flex items-center p-2 text-gray-700 hover:text-primary-600 transition" onClick={scrollToTop} data-id="element-241">
              <CartIcon data-id="element-242" />
            </Link>

            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-243">
              <span className="sr-only" data-id="element-244">Open main menu</span>
              {isMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-245" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-246" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu, show/hide based on menu state */}
      {isMenuOpen && <div className="lg:hidden" data-id="element-247">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-248">
            <Link to="/" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-249">
              Home
            </Link>

            <Link to="/about" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-250">
              About
            </Link>

            {/* Mobile services dropdown */}
            <div data-id="element-251">
              <button className="flex justify-between w-full px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => setIsMobileServicesOpen(!isMobileServicesOpen)} data-id="element-252">
                <span data-id="element-253">Packages</span>
                <ChevronDownIcon className="h-5 w-5" data-id="element-254" />
              </button>
              {isMobileServicesOpen && <div className="pl-6" data-id="element-255">
                  <Link to="/softplay" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => {
              setIsMenuOpen(false);
              scrollToTop();
            }} data-id="element-256">
                    Colorful Soft Play
                  </Link>
                  <Link to="/luxurysoftplay" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => {
              setIsMenuOpen(false);
              scrollToTop();
            }} data-id="element-257">
                    Luxury Soft Play
                  </Link>
                  <Link to="/bouncehouse" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => {
              setIsMenuOpen(false);
              scrollToTop();
            }} data-id="element-258">
                    Bounce Houses
                  </Link>
                </div>}
            </div>

            <Link to="/gallery" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-259">
              Gallery
            </Link>

            <Link to="/faq" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-260">
              FAQ
            </Link>

            <Link to="/contact" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-600" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-261">
              Contact
            </Link>

            <Link to="/cart" className="block w-full text-center px-6 py-3 mt-4 border-2 border-secondary-500 text-base font-bold rounded-full shadow-sm text-white bg-secondary-500 hover:bg-secondary-600" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-262">
              BOOK NOW
            </Link>
          </div>
        </div>}
    </header>;
};